import { asyncRoute } from '../../router';

export default asyncRoute(() =>
  import(/* webpackChunkName: "ForgotPasswordContainer" */ './container/ForgotPasswordContainer')
);
